export default __webpack_public_path__ + "static/media/avatar_29.1adbc3c4.png";